
class MessageFactory {
  activityId;
  content;
  direction;
  dateTime;
  error;

  constructor({
    content,
    activityId,
    direction,
    dateTime,
    error
    }) {
    this.content = content;
    this.activityId = activityId;
    this.direction = direction;
    this.dateTime = dateTime;
    this.error = error;
  }
}

export default MessageFactory;



// WEBPACK FOOTER //
// ./chat-app/services/messageFactory.js